import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  RiderDispatchBatch,
  RiderDispatchBatchVariables
} from "./types/RiderDispatchBatch";
import {
  RiderDispatchBatches,
  RiderDispatchBatchesVariables
} from "./types/RiderDispatchBatches";

const riderDispatchBatchesQuery = gql`
  query RiderDispatchBatches(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: RiderDispatchBatchFilterInput
    $sortBy: RiderDispatchBatchSortingInput
  ) {
    riderDispatchBatches(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
      sortBy: $sortBy
    ) {
      edges {
        node {
          id
          batchCode
          rider {
            id
            firstName
            lastName
          }
          created
          deliveryDate
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const useDispatchListQuery = makeQuery<
  RiderDispatchBatches,
  RiderDispatchBatchesVariables
>(riderDispatchBatchesQuery);

const riderDispatchBatchQuery = gql`
  query RiderDispatchBatch($id: ID!) {
    riderDispatchBatch(id: $id) {
      id
      batchCode
      rider {
        id
        firstName
        lastName
      }
      created
      deliveryDate
      orders {
        id
        orderCode
        user {
          id
          firstName
          lastName
        }
        shippingAddress {
          id
          unitDetails
          streetBrgy
          streetAddress1
          streetAddress2
          landmark
          city
          cityArea
          postalCode
          country {
            country
          }
          longitude
          latitude
        }
        payments {
          paymentMethodType
        }
        total {
          gross {
            amount
          }
        }
        specialNotes
        customerNote
      }
    }
  }
`;

export const useTripInformationList = makeQuery<
  RiderDispatchBatch,
  RiderDispatchBatchVariables
>(riderDispatchBatchQuery);
